module.exports = __webpack_public_path__ + "img/index_listBack.84fbf6f7.png";